(()=>{
  const preference=window.matchMedia('(prefers-reduced-motion: reduce)');
  const seen=new WeakSet();
  const running=new Set();
  const selectors='.section-heading,.moment-grid>a,.product-card,.about-gallery figure,.value-grid article,.distribution-options article,.blog-tile,.story-text,.closing h2';
  const animate=(element,frames,options)=>{
    if(preference.matches||window.Shopify?.designMode||!element.animate)return;
    const animation=element.animate(frames,options);
    running.add(animation);
    animation.finished.catch(()=>{}).finally(()=>running.delete(animation));
  };
  const observer='IntersectionObserver' in window?new IntersectionObserver(entries=>{
    entries.forEach(entry=>{
      if(!entry.isIntersecting)return;
      observer.unobserve(entry.target);
      animate(entry.target,[{opacity:.65,transform:'translateY(24px)'},{opacity:1,transform:'translateY(0)'}],{duration:650,easing:'cubic-bezier(.2,.7,.2,1)'});
    });
  },{threshold:.12}):null;
  function init(root=document){
    root.querySelectorAll(selectors).forEach(element=>{
      if(seen.has(element))return;
      seen.add(element);
      if(!preference.matches&&!window.Shopify?.designMode)observer?.observe(element);
    });
    root.querySelectorAll('.ribbon').forEach(ribbon=>{
      if(seen.has(ribbon))return;
      seen.add(ribbon);
      const track=document.createElement('div');
      track.className='jb-ticker-track';
      while(ribbon.firstChild)track.append(ribbon.firstChild);
      ribbon.append(track);
      animate(track,[{transform:'translateX(28px)'},{transform:'translateX(0)'}],{duration:4000,easing:'ease-out'});
    });
  }
  preference.addEventListener('change',()=>{if(preference.matches){observer?.disconnect();running.forEach(animation=>animation.cancel());}});
  document.addEventListener('shopify:section:load',event=>init(event.target));
  document.addEventListener('shopify:section:unload',event=>event.target.querySelectorAll(selectors).forEach(element=>observer?.unobserve(element)));
  init();
})();
